import { graphql } from 'relay-runtime';

export const ServicesFragment = graphql`
  fragment Services_userProfile on UserProfile {
    productizedServices(excludeDrafts: true) {
      edges {
        node {
          analyticsId
          id
          slug
          title
          portfolioProjects {
            edges {
              node {
                analyticsId
                id
                title
                slug
                cover {
                  ... on PortfolioProjectImageCover {
                    __typename
                    image {
                      id
                      animated
                      height
                      originalFormat
                      sizeBytes
                      uid
                      width
                    }
                  }
                  ... on PortfolioProjectTextCover {
                    __typename
                    style
                  }
                }
              }
            }
          }
          productizedServiceType
          duration {
            amount
            interval
          }
          price {
            type
            interval
            amount
            timeline
          }
        }
      }
    }
  }
`;
